import { render } from "./Monitor.vue?vue&type=template&id=991478e4"
import script from "./Monitor.vue?vue&type=script&lang=js"
export * from "./Monitor.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Monitor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "991478e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('991478e4', __exports__)) {
    api.reload('991478e4', __exports__)
  }
  
  module.hot.accept("./Monitor.vue?vue&type=template&id=991478e4", () => {
    api.rerender('991478e4', render)
  })

}


export default __exports__